import React from 'react';
import CourseCard from './CourseCard';
import { courses } from './courses_data';

function CoursesDevsContainer() {
  return (
    <div
      className={
        'md:p-5 flex flex-col scrollbar-hide max-h-[calc(100vh_-_166px)] min-h-[calc(100vh_-_166px)] md:max-h-[calc(100vh_-_136px)] md:min-h-[calc(100vh_-_136px)] w-full overflow-y-scroll'
      }
    >
      <div
        className={
          'grid grid-cols-3 gap-4 auto-rows-max auto-cols-max grid-flow-row-dense'
        }
      >
        {courses.map((course) => {
          return (
            <div key={course.index}>
              <CourseCard course={course} />
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default CoursesDevsContainer;
